import { useState, type FormEvent } from "react";
import { api } from "../../api";
import { authStore } from "../../auth/store";
import { Turnstile, turnstileSiteKey } from "../../auth/Turnstile";
import { BusyButton, Field } from "../../components/ui";
import { AuthFrame } from "../../routes/auth/LoginPage";

/** The page people see while the platform owner has the product closed. */
export function ComingSoon({ signedIn = false }: { signedIn?: boolean }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileTry, setTurnstileTry] = useState(0);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.launch.notify(email.trim(), turnstileToken);
      setDone(true);
    } catch (err) {
      setError((err as Error).message || "Could not save that email.");
      setTurnstileToken("");
      setTurnstileTry((n) => n + 1);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthFrame title="Coming soon" lead="Backstory is not open yet. Leave your email and we will tell you when it is available.">
      {done ? (
        <p>You're on the list.</p>
      ) : (
        <form onSubmit={submit} noValidate autoComplete="off">
          <Field label="Email" error={error ?? undefined}>
            {(p) => (
              <input
                {...p}
                className="input"
                type="email"
                inputMode="email"
                autoComplete="off"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            )}
          </Field>
          <Turnstile key={turnstileTry} onToken={setTurnstileToken} />
          <BusyButton className="btn primary block" type="submit" busy={busy} busyLabel="Saving…" disabled={!email.trim() || (!!turnstileSiteKey() && !turnstileToken)}>
            Notify me
          </BusyButton>
        </form>
      )}
      {signedIn && (
        <div className="auth-links">
          <button type="button" className="btn ghost" onClick={() => void authStore.logout()}>
            Sign out
          </button>
        </div>
      )}
    </AuthFrame>
  );
}
